import type { MapData, Player } from './types';

export class Minimap {
  private canvas: HTMLCanvasElement;
  private ctx: CanvasRenderingContext2D;
  private scale: number = 10; // pixels par case de map

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Could not get 2D context for minimap');
    this.ctx = ctx;
  }

  render(map: MapData, player: Player): void {
    const ctx = this.ctx;
    const scale = this.scale;

    // Effacer
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    // Fond semi-transparent
    ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
    ctx.fillRect(0, 0, map.w * scale, map.h * scale);

    // Dessiner la carte
    for (let y = 0; y < map.h; y++) {
      for (let x = 0; x < map.w; x++) {
        const tile = map.tiles[y * map.w + x];
        
        if (tile > 0) {
          // Mur
          ctx.fillStyle = tile === 1 ? '#666' : '#888';
          ctx.fillRect(x * scale, y * scale, scale, scale);
        }
      }
    }

    // Grille
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.1)';
    ctx.lineWidth = 1;
    for (let x = 0; x <= map.w; x++) {
      ctx.beginPath();
      ctx.moveTo(x * scale, 0);
      ctx.lineTo(x * scale, map.h * scale);
      ctx.stroke();
    }
    for (let y = 0; y <= map.h; y++) {
      ctx.beginPath();
      ctx.moveTo(0, y * scale);
      ctx.lineTo(map.w * scale, y * scale);
      ctx.stroke();
    }

    // Dessiner le joueur
    const px = player.x * scale;
    const py = player.y * scale;

    // Point du joueur
    ctx.fillStyle = '#0f0';
    ctx.beginPath();
    ctx.arc(px, py, 3, 0, Math.PI * 2);
    ctx.fill();

    // Direction du joueur (utilise dirX/dirY au lieu d'angle)
    const dirLength = 15;
    const dx = player.dirX * dirLength;
    const dy = player.dirY * dirLength;

    ctx.strokeStyle = '#0f0';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(px, py);
    ctx.lineTo(px + dx, py + dy);
    ctx.stroke();

    // Bordure
    ctx.strokeStyle = '#fff';
    ctx.lineWidth = 2;
    ctx.strokeRect(0, 0, map.w * scale, map.h * scale);
  }

  resize(map: MapData): void {
    this.canvas.width = map.w * this.scale;
    this.canvas.height = map.h * this.scale;
  }
}
